import {isBrandCatalogRequest,type BrandCatalogRequest} from './brand-catalog';
import {isBgmRequest,type BgmRequest} from './bgm-catalog';
import {isVoiceCatalogRequest,type VoiceCatalogRequest} from './voice-catalog';
export function isHostReadRequest(value:unknown):value is BgmRequest|VoiceCatalogRequest|BrandCatalogRequest {
  return isBgmRequest(value)||isVoiceCatalogRequest(value)||isBrandCatalogRequest(value);
}
